import React, { Fragment, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import axios from "services/interceptor/Interceptor";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// import FormSection from "../../formSection/formSection";
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from "assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ButtonWithIcon from "components/sales/buttons/buttonWithIcon/buttonWithIcon";
import { handleValidateObj } from "constants/objValues/objvalues";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import Inventory from "components/sales/inventory/inventory";
import { DatePickerInput } from "rc-datepicker";
import { Button, FormGroup, Table } from "react-bootstrap";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { imageUploadUrlPublic } from "services/redux/fileUpload/action";
import * as moment from "moment";
import ModalPop from "components/sales/modal/modal";
// import s from "./addAdvance.module.css";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Config from "services/config/config";
import { Toast } from "bootstrap";
import { showToast } from "services/utils/networks/network";
import AppNotifications from "components/sales/appNotifications/appNotifications";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Images from 'assets/images/imageData';


const ComplainList = ({
    showProjectListPopup,
    onClosePopup = () => { },
    onCloseHidePopup = () => { },
    existingComplainList
}) => {
    
  const { baseUrl } = useContext(BaseUrl);
    const [details, setDetails] = useState(null);
    useEffect(() => {
        console.log(existingComplainList);
        if (existingComplainList) {
          setDetails(existingComplainList);
        }
      }, [existingComplainList]);

  const handleSubmit = () => {
    onClosePopup();
  }

  return (
    <>
      <ModalPop
        title={"Existing Complain"}
        show={showProjectListPopup}
        handleModalHide={() => {onCloseHidePopup();}}
      >
        <Fragment>
            {details &&
            Object.keys(details).length !== 0 && (
                <div className="panel-card">
                <div className="panel-heading">List of existing complain against this site.</div>
                <div className="panel-body">
                    <div className="details-list">
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>Site Name</th>
                            <th>FD Ticket Id</th>
                            <th>Complain Raised By</th>
                            <th>Complain Type</th>
                            <th>status</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {details &&
                            details &&
                            details.map((val) => {
                            return (
                                <tr>
                                <td>{val.site_name}({val.site_no})</td>
                                <td>{val.fd_ticket_id}</td>
                                <td>{val.complain_raised_by}</td>
                                <td>{val.complain_type}</td>
                                <td>{val.status}</td>
                                <td>{val?.id && <a href={`${baseUrl}/edit-and-merge-complain/` + val.id}>Edit Complain</a>}</td>
                                </tr>
                            );
                            })}
                        </tbody>
                    </Table>
                    </div>
                </div>
                </div>
            )}
            
        </Fragment>
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.addNewComplain}
        </Button>
      </ModalPop>
    </>
  );
};
ComplainList.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      imageUploadUrlPublic,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(ComplainList);
